import { z } from 'zod';
export const ATTENTION_KEYS = [
    'renewals_pending',
    'tickets_escalated',
    'facility_requests',
    'installs_locked',
    'installs_silent',
    'rows_parked',
    'updates_failed',
    'licences_not_applied',
    'profile_conflicts',
    'endings_soon',
    'open_ended',
    'closures_due',
    'owner_cover',
];
export const ATTENTION_RULES = {
    renewals_pending: { capability: 'desk.renewal.read', label: 'Renewals waiting for a decision', to: '/owner/renewals', tone: 'warning' },
    tickets_escalated: { capability: 'desk.ticket.read', label: 'Escalated tickets', to: '/owner/tickets', tone: 'warning' },
    facility_requests: { capability: 'facility_request.read', label: 'Facility requests waiting', to: '/owner/facility-requests', tone: 'info' },
    installs_locked: { capability: 'deployment.fleet', label: 'Offline servers locked', to: '/owner/offline-installs', tone: 'danger' },
    installs_silent: { capability: 'deployment.fleet', label: 'Offline servers silent for over a day', to: '/owner/offline-installs', tone: 'warning' },
    rows_parked: { capability: 'deployment.fleet', label: 'Servers with parked sync rows this week', to: '/owner/offline-installs', tone: 'warning' },
    updates_failed: { capability: 'deployment.fleet', label: 'Failed updates this week', to: '/owner/offline-installs', tone: 'warning' },
    licences_not_applied: { capability: 'deployment.fleet', label: 'Licences not applied for over a day', to: '/owner/offline-installs', tone: 'warning' },
    profile_conflicts: { capability: 'deployment.fleet', label: 'Facility profile conflicts', to: '/owner/offline-installs', tone: 'warning' },
    endings_soon: { capability: 'tenant.read', label: 'Subscriptions or trials ending within 14 days', to: '/owner/tenants', tone: 'info' },
    open_ended: { capability: 'tenant.commercial.update', label: 'Facilities with no subscription end date', to: '/owner/tenants', tone: 'info' },
    closures_due: { capability: 'tenant.closure', label: 'Closures and deletions due within 7 days', to: '/owner/tenants', tone: 'danger' },
    owner_cover: { capability: 'owner.read', label: 'Fewer than two owners can sign in with an authenticator', to: '/owner/owners', tone: 'danger' },
};
export const PLATFORM_AUDIT_ACTOR_TYPES = ['owner', 'platform_user', 'tenant_user', 'system'];
export const platformAuditQuerySchema = z.object({
    tenantId: z.string().uuid().optional(),
    action: z.string().trim().min(2).max(80).optional(),
    actorType: z.enum(PLATFORM_AUDIT_ACTOR_TYPES).optional(),
    cursor: z.string().max(200).optional(),
    limit: z.coerce.number().int().min(1).max(100).default(50),
});
//# sourceMappingURL=owner-console.js.map